import { useParams } from "react-router-dom";
import Chat from "./Chat";

const ChatWrapper = () => {
  const { matchId } = useParams();
  return <Chat receiverId={matchId} />;
};

export default ChatWrapper;
